interface FiltrosState {
  tipo: number | undefined;
  tipoProduto: string | undefined;
  produto: number | undefined;
  startDate: Date;
  endDate: Date;
}

type FiltrosActionTypes = 'setTipo' | 'setTipoProduto' | 'setProduto' | 'setStartDate' | 'setEndDate';

interface FiltrosAction {
  type: FiltrosActionTypes;
  value?: any;
}

const today = new Date();
const initialStartDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 4, 0, 0, 0);
const initialEndDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 4, 23, 59, 59);

export const filtrosInitialState: FiltrosState = {
  tipo: undefined,
  tipoProduto: undefined,
  produto: undefined,
  startDate: initialStartDate,
  endDate: initialEndDate,
};

export const filtrosReducer = (state: FiltrosState, action: FiltrosAction): FiltrosState => {
  switch (action.type) {
    case 'setTipo':
      return { ...state, tipo: action.value };
    case 'setTipoProduto':
      return { ...state, tipoProduto: action.value };
    case 'setProduto':
      return { ...state, produto: action.value };
    case 'setStartDate':
      return { ...state, startDate: action.value };
    case 'setEndDate':
      return { ...state, endDate: action.value };
    default:
      return state;
  }
};
